import { render } from "./Component.vue?vue&type=template&id=4ff655bc&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"

import "./Component.vue?vue&type=style&index=0&id=4ff655bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff655bc"]])

export default __exports__